<main class="c-main">
  <div class="container-fluid">
    <div class="mat-elevation-z8">
      <mat-card>
        <div class="wow-form-header">
          <div class="wow-form-header__icon"><mat-icon>{{ icone }}</mat-icon></div>
          <mat-card-title>{{ titulo }}</mat-card-title>
        </div>

        <mat-card class="rel-card">
          <div class="row">

            <!-- Período (todos) -->
            <div class="col-12 col-md-3">
              <mat-form-field appearance="fill" class="full-width">
                <mat-label>Data início</mat-label>
                <input matInput [matDatepicker]="ini" [(ngModel)]="dataInicio">
                <mat-datepicker-toggle matSuffix [for]="ini"></mat-datepicker-toggle>
                <mat-datepicker #ini></mat-datepicker>
              </mat-form-field>
            </div>
            <div class="col-12 col-md-3">
              <mat-form-field appearance="fill" class="full-width">
                <mat-label>Data fim</mat-label>
                <input matInput [matDatepicker]="fim" [(ngModel)]="dataFim">
                <mat-datepicker-toggle matSuffix [for]="fim"></mat-datepicker-toggle>
                <mat-datepicker #fim></mat-datepicker>
              </mat-form-field>
            </div>

            <!-- Contas a Receber -->
            <ng-container *ngIf="tipo === 'contasReceber'">
              <div class="col-12 col-md-3">
                <mat-form-field appearance="fill" class="full-width">
                  <mat-label>Tipo de filtro</mat-label>
                  <mat-select [(ngModel)]="tipoFiltro">
                    <mat-option value="">Vencimento</mat-option>
                    <mat-option value="Recebimento">Recebimento</mat-option>
                    <mat-option value="Pagador">Pagador</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="col-12 col-md-3">
                <mat-form-field appearance="fill" class="full-width">
                  <mat-label>Situação</mat-label>
                  <mat-select [(ngModel)]="ctSituacao">
                    <mat-option value="">Todas</mat-option>
                    <mat-option *ngFor="let o of situacaoReceberOpcoes" [value]="o.valor">{{ o.label }}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="col-12 col-md-3">
                <mat-form-field appearance="fill" class="full-width">
                  <mat-label>Segmento</mat-label>
                  <mat-select [(ngModel)]="ctSegmentoId">
                    <mat-option [value]="null">Todos</mat-option>
                    <mat-option *ngFor="let s of segmentos" [value]="s.id">{{ s.nome }}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="col-12 col-md-3">
                <mat-form-field appearance="fill" class="full-width">
                  <mat-label>Pagador (opcional)</mat-label>
                  <input matInput [(ngModel)]="pagador">
                </mat-form-field>
              </div>
            </ng-container>

            <!-- Contas a Pagar -->
            <ng-container *ngIf="tipo === 'contasPagar'">
              <div class="col-12 col-md-3">
                <mat-form-field appearance="fill" class="full-width">
                  <mat-label>Tipo de filtro</mat-label>
                  <mat-select [(ngModel)]="tipoFiltro">
                    <mat-option value="">Vencimento</mat-option>
                    <mat-option value="Pagamento">Pagamento</mat-option>
                    <mat-option value="Favorecido">Favorecido</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="col-12 col-md-3">
                <mat-form-field appearance="fill" class="full-width">
                  <mat-label>Situação</mat-label>
                  <mat-select [(ngModel)]="ctSituacao">
                    <mat-option value="">Todas</mat-option>
                    <mat-option *ngFor="let o of situacaoPagarOpcoes" [value]="o.valor">{{ o.label }}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="col-12 col-md-3">
                <mat-form-field appearance="fill" class="full-width">
                  <mat-label>Segmento</mat-label>
                  <mat-select [(ngModel)]="ctSegmentoId">
                    <mat-option [value]="null">Todos</mat-option>
                    <mat-option *ngFor="let s of segmentos" [value]="s.id">{{ s.nome }}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="col-12 col-md-3">
                <mat-form-field appearance="fill" class="full-width">
                  <mat-label>Favorecido (opcional)</mat-label>
                  <input matInput [(ngModel)]="pagador">
                </mat-form-field>
              </div>
            </ng-container>

            <!-- Tickets -->
            <ng-container *ngIf="tipo === 'tickets'">
              <div class="col-12 col-md-3">
                <mat-form-field appearance="fill" class="full-width">
                  <mat-label>Segmento</mat-label>
                  <mat-select [(ngModel)]="tkSegmento">
                    <mat-option value="">Todos</mat-option>
                    <mat-option *ngFor="let s of segmentos" [value]="s.codigo">{{ s.nome }}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="col-12 col-md-3">
                <mat-form-field appearance="fill" class="full-width">
                  <mat-label>Status</mat-label>
                  <mat-select [(ngModel)]="tkStatus">
                    <mat-option value="">Todos</mat-option>
                    <mat-option *ngFor="let o of statusOpcoes" [value]="o.valor">{{ o.label }}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="col-12 col-md-3">
                <mat-form-field appearance="fill" class="full-width">
                  <mat-label>Prioridade</mat-label>
                  <mat-select [(ngModel)]="tkPrioridade">
                    <mat-option value="">Todas</mat-option>
                    <mat-option *ngFor="let o of prioridadeOpcoes" [value]="o.valor">{{ o.label }}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="col-12 col-md-3">
                <mat-form-field appearance="fill" class="full-width">
                  <mat-label>Tipo</mat-label>
                  <mat-select [(ngModel)]="tkTipo">
                    <mat-option value="">Todos</mat-option>
                    <mat-option *ngFor="let o of tipoOpcoes" [value]="o.valor">{{ o.label }}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="col-12 col-md-3">
                <mat-form-field appearance="fill" class="full-width">
                  <mat-label>ID (opcional)</mat-label>
                  <input matInput type="number" [(ngModel)]="tkId">
                </mat-form-field>
              </div>
              <div class="col-12 col-md-3">
                <mat-form-field appearance="fill" class="full-width">
                  <mat-label>Assunto (opcional)</mat-label>
                  <input matInput [(ngModel)]="tkAssunto">
                </mat-form-field>
              </div>
            </ng-container>

            <!-- Clientes -->
            <ng-container *ngIf="tipo === 'clientes'">
              <div class="col-12 col-md-3">
                <mat-form-field appearance="fill" class="full-width">
                  <mat-label>Tipo de filtro</mat-label>
                  <mat-select [(ngModel)]="tipoFiltro">
                    <mat-option value="">Todos</mat-option>
                    <mat-option value="Razão Social">Razão Social</mat-option>
                    <mat-option value="Telefone">Telefone</mat-option>
                    <mat-option value="Quadra">Quadra</mat-option>
                    <mat-option value="Endereço">Endereço</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="col-12 col-md-3">
                <mat-form-field appearance="fill" class="full-width">
                  <mat-label>Parâmetro (opcional)</mat-label>
                  <input matInput [(ngModel)]="clParametro">
                </mat-form-field>
              </div>
            </ng-container>

          </div>

          <div class="rel-card__acoes">
            <button mat-raised-button color="primary" [disabled]="gerando" (click)="gerar()">
              <mat-icon>description</mat-icon> Gerar relatório
            </button>
          </div>
        </mat-card>

      </mat-card>
    </div>
  </div>
</main>
